var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16 27c6.018 0 11-4.993 11-11 0-6.018-4.993-11-11.011-11C9.982 5 5 9.982 5 16c0 6.007 4.993 11 11 11zm-1.005-8.997c0 .656.364.997 1.005.997.63 0 1.017-.401 1.017-.9l.006-1.132c0-.706.399-1.156 1.27-1.728C19.503 14.438 20 13.708 20 12.2c0-2.093-1.852-3.2-3.982-3.2-2.154 0-3.346 1.005-3.897 2.165-.06.195-.121.414-.121.62 0 .56.46.864.871.864.57 0 .754-.24 1.014-.577.067-.085.138-.178.221-.274.411-.681 1.004-1.095 1.84-1.095 1.125 0 2.238.645 2.238 1.594 0 .851-.52 1.265-1.61 2.031-.895.633-1.573 1.29-1.573 2.53zm-.369 3.695c0 .718.63 1.302 1.356 1.302s1.355-.572 1.355-1.302-.617-1.314-1.355-1.314c-.739 0-1.356.596-1.356 1.314z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/Question_Circle.506aa0a291ace51212d068e7cebf45ea.svg";
export { ForwardRef as ReactComponent };